@if (data.image) {
    <div class="dialog-top dialog-popup" [attr.data-popup-type]="data.dialog_popup_type">
        <img src="{{data.image}}" alt="{{data.image_alt}}">
    </div>
}

@if (data.title) {
    <div mat-dialog-title>
        <h2 class="mt-xl mb-0" [innerHTML]="data.title"></h2>
    </div>
}

@if (data.body) {
    <div mat-dialog-content>
        <div [innerHTML]="data.body"></div>
    </div>
}

@if (data.button) {
    <div mat-dialog-actions class="text-center my-4 d-flex justify-content-center align-items-center">
        <button class="btn btn-primary cursor-pointer mt-0" [mat-dialog-close]="false"
                (click)="onClick(data.image_alt)">{{ data.button }}
        </button>
    </div>
}